import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Alert, FormGroup, Label, Input,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import KullaniciIletisimModal from "../../../components/Common/KullaniciIletisimModal";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const DegerlemeTalepleri = () => {
  document.title = "Değerlendirme Talepleri | HarmanaGEL";

  const [talepler, setTalepler] = useState([]);
  // Yeni değerleme ilanı AKTIF_DURUM='Beklemede' başlar; yayına girmesi için admin
  // onayı şart. Sayfanın "bekleyen" göstergesi bunu saymalı — talep (tahmin)
  // kayıtlarının DURUM'unu değil.
  const [bekleyenIlanlar, setBekleyenIlanlar] = useState([]);
  const [aktifSekme, setAktifSekme] = useState("bekleyen");
  const [onayLoading, setOnayLoading] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  // Talep sahibine uyarı bildirimi / arama ("yanlış değerleme açtın" vb.)
  const [iletisimTalep, setIletisimTalep] = useState(null);
  const [ilanDurumLoading, setIlanDurumLoading] = useState(null);
  const [sureLoading, setSureLoading] = useState(null); // süresi ayarlanan ilan ID'si
  const [aktifDegerlemeler, setAktifDegerlemeler] = useState([]);
  const [selectedTalep, setSelectedTalep] = useState(null);
  const [editUzmanId, setEditUzmanId] = useState("");
  const [editDurum, setEditDurum] = useState("");
  const [editLoading, setEditLoading] = useState(false);

  const fetchTalepler = async () => {
    setIsLoading(true);
    setError(null);
    try {
      // DEGERLEME_TALEPLERI'nde EF tek navigation tanımlı: KULLANICILAR (TALEP_EDEN_KULLANICI_ID).
      // DEGERLEME_UZMANI_ID için ayrı navigation yok → KULLANICILAR1 expand 400 dönerdi.
      // Uzman bilgisini ayrı bir lookup ile çekip listeye eşliyoruz.
      const response = await fetch(
        `${BASE_URL}/DEGERLEME_TALEPLERI?$top=500&$orderby=TALEP_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO),ILANLAR($select=ID,AD,AKTIF_DURUM,FIYAT,PARA_BIRIMI,KIMDEN_ID,DEGERLEMEYE_ACIK_MI,BITIS_TARIHI,GORSEL_YOLU,ACIKLAMA,KONUM_IL,KONUM_ILCE)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      const list = (result && result.value) || [];

      // Uzman ID'lerini topluca KULLANICILAR'dan çek
      const uzmanIds = Array.from(new Set(list.map(t => t.DEGERLEME_UZMANI_ID).filter(Boolean)));
      let uzmanMap = {};
      if (uzmanIds.length > 0) {
        const filterStr = uzmanIds.map(id => `ID eq ${id}`).join(' or ');
        const uzRes = await fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD&$filter=${filterStr}`, { headers: getAuthHeaders() });
        const uzJson = await uzRes.json();
        (uzJson?.value || []).forEach(u => { uzmanMap[u.ID] = u; });
      }
      // Talep nesnelerine uzman bilgisini ekle (KULLANICILAR1 yerine UZMAN field'ı)
      const enriched = list.map(t => ({
        ...t,
        UZMAN: t.DEGERLEME_UZMANI_ID ? uzmanMap[t.DEGERLEME_UZMANI_ID] || null : null,
      }));
      setTalepler(enriched);
    } catch (err) {
      setError("Talepler yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  // Onaylanmış değerleme ilanları — süresi işleyen (Aktif) veya dolmuş (Pasif).
  // Onay bekleyenler hariç; onların süresi henüz başlamamıştır.
  const fetchAktifDegerlemeler = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/ILANLAR?$top=200&$orderby=BITIS_TARIHI desc` +
          `&$filter=DEGERLEMEYE_ACIK_MI eq true and AKTIF_DURUM ne 'Beklemede'` +
          `&$expand=KULLANICILAR($select=AD_SOYAD,CEP_NO),KATEGORILER($select=AD,ID)`,
        { headers: getAuthHeaders() }
      );
      const json = await res.json();
      setAktifDegerlemeler(json?.value || []);
    } catch {
      setAktifDegerlemeler([]);
    }
  };

  const fetchBekleyenIlanlar = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/ILANLAR?$top=200&$orderby=OLUSTURMA_TARIHI desc` +
          `&$filter=DEGERLEMEYE_ACIK_MI eq true and AKTIF_DURUM eq 'Beklemede'` +
          `&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO),KATEGORILER($select=AD,ID)`,
        { headers: getAuthHeaders() }
      );
      const json = await res.json();
      setBekleyenIlanlar(json?.value || []);
    } catch {
      setBekleyenIlanlar([]);
    }
  };

  // Onay = ilanı yayına al. Değerleme ilanında 60 dakikalık (1 saat) tahmin süresi
  // onay anında başlar (IlanYonetimi ve server ile aynı kural).
  const handleIlanOnayla = async (ilan) => {
    setOnayLoading(ilan.ID);
    try {
      const bitis = new Date();
      bitis.setMinutes(bitis.getMinutes() + 60);
      const res = await fetch(`${BASE_URL}/ILANLAR(${ilan.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ AKTIF_DURUM: "Aktif", BITIS_TARIHI: bitis.toISOString() }),
      });
      if (!res.ok) { setError("İlan onaylanamadı."); return; }
      setSuccessMsg(`İlan #${ilan.ID} onaylandı — 1 saatlik değerleme süresi başladı.`);
      fetchBekleyenIlanlar();
      fetchTalepler();
      fetchAktifDegerlemeler();
      setTimeout(() => setSuccessMsg(""), 4000);
    } catch {
      setError("İlan onaylanamadı.");
    } finally {
      setOnayLoading(null);
    }
  };

  // ─── DEĞERLEME SÜRESİ (admin) ────────────────────────────────
  // Değerleme süresi ayrı bir alanda değil: ilan değerlemeye açıldığında
  // ILANLAR.BITIS_TARIHI = şimdi + 60 dk kurulur ve DegerlemeJobs süresi
  // dolanı "Pasif" yapar. Bu yüzden süreyi değiştirmek = BITIS_TARIHI'ni
  // ileri/geri almak. Backend /api/AdminSure/Degerleme bunu tek yerde yapar,
  // gerekirse ilanı yeniden "Aktif" eder ve mobil listeye sinyal atar.
  const degerlemeSureAyarla = async ({ ilanId, ekDakika, yeniBitisTarihi, yenidenAktif }) => {
    setSureLoading(ilanId);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminSure/Degerleme`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          IlanId: ilanId,
          EkDakika: ekDakika ?? null,
          YeniBitisTarihi: yeniBitisTarihi || null,
          YenidenAktifEt: !!yenidenAktif,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.basarili) {
        setError(data.message || data.Message || "Değerleme süresi ayarlanamadı.");
        return;
      }
      setSuccessMsg(`İlan #${ilanId} değerleme süresi güncellendi.`);
      fetchTalepler();
      fetchBekleyenIlanlar();
      fetchAktifDegerlemeler();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Değerleme süresi ayarlanırken hata oluştu.");
    } finally {
      setSureLoading(null);
    }
  };

  // Süresi dolmuş değerlemeyi yeniden aç
  const handleDegerlemeYenidenAc = async (ilan) => {
    const dk = window.prompt(
      `İlan #${ilan.ID} değerlemesi yeniden açılacak.\n\nKaç dakika süre verilsin?`,
      "60"
    );
    if (dk === null) return;
    const dakika = parseInt(dk, 10);
    if (!Number.isFinite(dakika) || dakika <= 0) {
      setError("Geçerli bir dakika girin.");
      return;
    }
    await degerlemeSureAyarla({
      ilanId: ilan.ID,
      yeniBitisTarihi: new Date(Date.now() + dakika * 60000).toISOString(),
      yenidenAktif: true,
    });
  };

  const handleIlanReddet = async (ilan) => {
    if (!window.confirm(`İlan #${ilan.ID} reddedilsin mi? (Pasif'e alınır, yayına girmez.)`)) return;
    setOnayLoading(ilan.ID);
    try {
      const res = await fetch(`${BASE_URL}/ILANLAR(${ilan.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ AKTIF_DURUM: "Pasif" }),
      });
      if (!res.ok) { setError("İlan reddedilemedi."); return; }
      setSuccessMsg(`İlan #${ilan.ID} reddedildi (Pasif).`);
      fetchBekleyenIlanlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("İlan reddedilemedi.");
    } finally {
      setOnayLoading(null);
    }
  };

  useEffect(() => {
    fetchTalepler();
    fetchBekleyenIlanlar();
    fetchAktifDegerlemeler();
  }, []);

  // Uygulamanın yazdığı tek sözlük: Beklemede / Kabul Edildi / Reddedildi.
  // ("Tamamlandı" ve "Atandı" hiçbir yerde üretilmiyordu; kabul edilen talepler
  // "Kabul Edildi" olarak kaydedildiği için panelde gri "Bilinmiyor" rozeti
  // alıyor, geri kalan her şey "Beklemede" görünüyordu.)
  const durumBadge = (durum) => {
    const renkler = { "Beklemede": "warning", "Kabul Edildi": "success", "Reddedildi": "danger" };
    return <Badge color={renkler[durum] || "secondary"}>{durum || "Beklemede"}</Badge>;
  };

  const ilanDurumBadge = (s) => {
    const lower = (s || "").toLowerCase();
    if (lower === "aktif") return <Badge color="success">Aktif</Badge>;
    if (lower === "pasif") return <Badge color="danger">Pasif</Badge>;
    if (lower === "beklemede") return <Badge color="warning">Beklemede</Badge>;
    if (lower === "silindi") return <Badge color="dark">Silindi</Badge>;
    return <Badge color="secondary">{s || "?"}</Badge>;
  };

  // İlanın yayın durumunu buradan değiştir. Değerleme ilanı "Aktif" yapılırken
  // 60 dakikalık (1 saat) değerleme süresi ONAYDA başlar (IlanYonetimi ile aynı kural).
  const handleIlanDurum = async (talep, yeniDurum) => {
    const ilan = talep.ILANLAR;
    const ilanId = ilan?.ID || talep.ILAN_ID;
    if (!ilanId || yeniDurum === ilan?.AKTIF_DURUM) return;
    setIlanDurumLoading(ilanId);
    try {
      const body = { AKTIF_DURUM: yeniDurum };
      if (yeniDurum === "Aktif" && ilan?.DEGERLEMEYE_ACIK_MI == true) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + 60);
        body.BITIS_TARIHI = now.toISOString();
      }
      const res = await fetch(`${BASE_URL}/ILANLAR(${ilanId})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify(body),
      });
      if (!res.ok) { setError("İlan durumu güncellenemedi."); return; }
      setSuccessMsg(`İlan #${ilanId} durumu "${yeniDurum}" yapıldı.`);
      fetchTalepler();
      fetchBekleyenIlanlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("İlan durumu güncellenemedi.");
    } finally {
      setIlanDurumLoading(null);
    }
  };

  const handleDeleteTalep = async (talep) => {
    if (!window.confirm(`Talep #${talep.ID} silinsin mi? Bu işlem geri alınamaz.`)) return;
    try {
      const res = await fetch(`${BASE_URL}/DEGERLEME_TALEPLERI(${talep.ID})`, {
        method: "DELETE",
        headers: getAuthHeaders(),
      });
      if (!res.ok) { setError("Talep silinemedi."); return; }
      setSuccessMsg(`Talep #${talep.ID} silindi.`);
      setDetailModal(false);
      fetchTalepler();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Talep silinemedi.");
    }
  };

  const handleOpenDetail = (talep) => {
    setSelectedTalep(talep);
    setDetailModal(true);
  };

  const handleOpenEdit = (talep) => {
    setSelectedTalep(talep);
    setEditUzmanId(talep.DEGERLEME_UZMANI_ID || "");
    setEditDurum(talep.DURUM || "Beklemede");
    setEditModal(true);
  };

  const handleEditSave = async () => {
    setEditLoading(true);
    try {
      const body = {};
      if (editUzmanId !== "" && editUzmanId !== null) body.DEGERLEME_UZMANI_ID = parseInt(editUzmanId);
      else body.DEGERLEME_UZMANI_ID = null;
      if (editDurum) body.DURUM = editDurum;

      await fetch(`${BASE_URL}/DEGERLEME_TALEPLERI(${selectedTalep.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify(body),
      });
      setSuccessMsg("Talep güncellendi.");
      setEditModal(false);
      fetchTalepler();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Güncelleme sırasında hata oluştu.");
    } finally {
      setEditLoading(false);
    }
  };

  // Not: talep (tahmin) kayıtlarının çoğu kalıcı olarak "Beklemede" kalır —
  // durum yalnız ilan sahibi bir tahmini kabul edince değişir. Bu yüzden
  // sayfanın uyarı sayacı bu değeri değil, onay bekleyen ilan sayısını kullanır.

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "İlan",
      accessorKey: "ILANLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const i = cell.getValue();
        return i ? <span className="fw-medium">{i.AD}</span> : <span className="text-muted">İlan #{cell.row.original.ILAN_ID}</span>;
      },
    },
    {
      header: "Talep Eden",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.row.original.TALEP_EDEN_KULLANICI_ID}</span>;
      },
    },
    {
      header: "Tahmini Değer",
      accessorKey: "TAHMINI_DEGER",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="fw-bold">{parseFloat(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</span> : "-";
      },
    },
    {
      header: "Karkas Kilo",
      accessorKey: "TAHMINI_KARKAS_KILO",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span>{parseFloat(v).toLocaleString("tr-TR")} kg</span> : "-";
      },
    },
    {
      header: "İlan Durumu",
      accessorKey: "ILANLAR",
      id: "ILAN_DURUM",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const t = cell.row.original;
        const ilan = t.ILANLAR;
        if (!ilan) return <span className="text-muted">İlan yok</span>;
        return (
          <div className="d-flex align-items-center gap-2">
            {ilanDurumBadge(ilan.AKTIF_DURUM)}
            <Input
              type="select"
              bsSize="sm"
              style={{ maxWidth: 120 }}
              value={ilan.AKTIF_DURUM || ""}
              disabled={ilanDurumLoading === ilan.ID}
              onChange={(e) => handleIlanDurum(t, e.target.value)}
              title="İlanın yayın durumunu değiştir"
            >
              <option value="Aktif">Aktif</option>
              <option value="Pasif">Pasif</option>
              <option value="Beklemede">Beklemede</option>
            </Input>
          </div>
        );
      },
    },
    {
      header: "Talep Durumu",
      accessorKey: "DURUM",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => durumBadge(cell.getValue()),
    },
    {
      header: "Talep Tarihi",
      accessorKey: "TALEP_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const t = cellProps.row.original;
        return (
          <div className="d-flex gap-2">
            <Button color="info" size="sm" outline title="Detay" onClick={() => handleOpenDetail(t)}>
              <i className="bx bx-detail me-1" /> Detay
            </Button>
            <Button color="secondary" size="sm" outline title="Sahibine bildirim / ara" onClick={() => setIletisimTalep(t)}>
              <i className="bx bx-message-rounded-dots" />
            </Button>
            <Button color="primary" size="sm" outline title="Talep durumunu değiştir" onClick={() => handleOpenEdit(t)}>
              <i className="bx bx-edit me-1" /> Düzenle
            </Button>

            {/* Değerleme süresi — ilan değerlemeye açıksa yönetilebilir.
                Süre = ILANLAR.BITIS_TARIHI; dolduğunda job ilanı Pasif yapar. */}
            {t.ILANLAR?.DEGERLEMEYE_ACIK_MI === true && (
              <UncontrolledDropdown>
                <DropdownToggle color="warning" size="sm" outline caret
                  title="Değerleme süresi" disabled={sureLoading === t.ILANLAR.ID}>
                  {sureLoading === t.ILANLAR.ID ? <Spinner size="sm" /> : <i className="bx bx-time-five" />}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem header>Süreyi uzat</DropdownItem>
                  {[15, 30, 60, 180].map((dk) => (
                    <DropdownItem key={dk}
                      onClick={() => degerlemeSureAyarla({ ilanId: t.ILANLAR.ID, ekDakika: dk, yenidenAktif: true })}>
                      +{dk} dakika
                    </DropdownItem>
                  ))}
                  <DropdownItem divider />
                  <DropdownItem onClick={() => handleDegerlemeYenidenAc(t.ILANLAR)}>
                    <i className="bx bx-refresh me-1" />
                    Yeniden aç (süre gir)…
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}

            <Button color="danger" size="sm" outline title="Talebi sil" onClick={() => handleDeleteTalep(t)}>
              <i className="bx bx-trash" />
            </Button>
          </div>
        );
      },
    },
  ], [ilanDurumLoading, talepler, sureLoading]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Değerlendirme Talepleri" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          {bekleyenIlanlar.length > 0 && (
            <Alert color="warning" className="d-flex align-items-center gap-3">
              <i className="bx bx-time fs-3" />
              <div className="flex-grow-1">
                <strong>{bekleyenIlanlar.length} değerleme ilanı onayınızı bekliyor.</strong>
                <div className="small">Onaylanana kadar ilan yayına girmez ve tahmin toplanmaz.</div>
              </div>
              <Button color="warning" size="sm" onClick={() => setAktifSekme("bekleyen")}>
                Onay Bekleyenler
              </Button>
            </Alert>
          )}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div className="btn-group btn-group-sm" role="group">
                      <Button
                        color={aktifSekme === "bekleyen" ? "warning" : "light"}
                        onClick={() => setAktifSekme("bekleyen")}
                        title="Yayına girmek için onayınızı bekleyen değerleme ilanları"
                      >
                        <i className="bx bx-time me-1" />
                        Onay Bekleyenler{bekleyenIlanlar.length > 0 ? ` (${bekleyenIlanlar.length})` : ""}
                      </Button>
                      <Button
                        color={aktifSekme === "talepler" ? "primary" : "light"}
                        onClick={() => setAktifSekme("talepler")}
                        title="Kullanıcıların ilanlara verdiği değer tahminleri"
                      >
                        <i className="bx bx-list-ul me-1" />
                        Gelen Tahminler ({talepler.length})
                      </Button>
                      {/* Onaylanmış, süresi işleyen değerlemeler. Süre uzatma/yeniden
                          açma yalnızca burada anlamlı — onay bekleyenlerin henüz
                          süresi başlamamıştır. */}
                      <Button
                        color={aktifSekme === "aktif" ? "success" : "light"}
                        onClick={() => setAktifSekme("aktif")}
                        title="Süresi devam eden veya dolmuş değerleme ilanları"
                      >
                        <i className="bx bx-time-five me-1" />
                        Süre Yönetimi{aktifDegerlemeler.length > 0 ? ` (${aktifDegerlemeler.length})` : ""}
                      </Button>
                    </div>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => { fetchTalepler(); fetchBekleyenIlanlar(); fetchAktifDegerlemeler(); }}
                      disabled={isLoading}
                      title="Listeyi yenile"
                    >
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {aktifSekme === "bekleyen" ? (
                    bekleyenIlanlar.length === 0 ? (
                      <div className="text-center text-muted py-5">
                        <i className="bx bx-check-circle fs-1 d-block mb-2 text-success" />
                        Onay bekleyen değerleme ilanı yok.
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>İlan</th>
                              <th>Sahibi</th>
                              <th>Kategori</th>
                              <th>Konum</th>
                              <th>Oluşturma</th>
                              <th style={{ width: 220 }}>İşlemler</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bekleyenIlanlar.map((ilan) => (
                              <tr key={ilan.ID}>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    {ilan.GORSEL_YOLU && (
                                      <img
                                        src={ilan.GORSEL_YOLU}
                                        alt=""
                                        style={{ width: 44, height: 44, objectFit: "cover", borderRadius: 4 }}
                                      />
                                    )}
                                    <div>
                                      <div className="fw-medium">{ilan.AD}</div>
                                      <small className="text-muted">#{ilan.ID}</small>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {ilan.KULLANICILAR?.AD_SOYAD || `#${ilan.KIMDEN_ID}`}
                                  {ilan.KULLANICILAR?.CEP_NO && (
                                    <small className="text-muted d-block">{ilan.KULLANICILAR.CEP_NO}</small>
                                  )}
                                </td>
                                <td>{ilan.KATEGORILER?.AD || "-"}</td>
                                <td>{[ilan.KONUM_ILCE, ilan.KONUM_IL].filter(Boolean).join(" / ") || "-"}</td>
                                <td>{ilan.OLUSTURMA_TARIHI ? new Date(ilan.OLUSTURMA_TARIHI).toLocaleString("tr-TR") : "-"}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Button
                                      color="success"
                                      size="sm"
                                      disabled={onayLoading === ilan.ID}
                                      onClick={() => handleIlanOnayla(ilan)}
                                      title="İlanı yayına al — 1 saatlik değerleme süresi başlar"
                                    >
                                      {onayLoading === ilan.ID
                                        ? <Spinner size="sm" className="me-1" />
                                        : <i className="bx bx-check me-1" />}
                                      Onayla
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      outline
                                      disabled={onayLoading === ilan.ID}
                                      onClick={() => handleIlanReddet(ilan)}
                                      title="İlanı Pasif'e al — yayına girmez"
                                    >
                                      <i className="bx bx-x me-1" />
                                      Reddet
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )
                  ) : aktifSekme === "aktif" ? (
                    aktifDegerlemeler.length === 0 ? (
                      <div className="text-center text-muted py-5">
                        <i className="bx bx-time-five fs-1 d-block mb-2" />
                        Onaylanmış değerleme ilanı yok.
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>İlan</th>
                              <th>Sahibi</th>
                              <th>Durum</th>
                              <th>Bitiş / Kalan</th>
                              <th style={{ width: 210 }}>Süre İşlemleri</th>
                            </tr>
                          </thead>
                          <tbody>
                            {aktifDegerlemeler.map((ilan) => {
                              const bitis = ilan.BITIS_TARIHI ? new Date(ilan.BITIS_TARIHI) : null;
                              const kalanMs = bitis ? bitis.getTime() - Date.now() : null;
                              const suresiDoldu = kalanMs !== null && kalanMs <= 0;
                              const kalanMetin =
                                kalanMs === null ? "—"
                                  : suresiDoldu ? "Süre doldu"
                                    : `${Math.floor(kalanMs / 60000)} dk kaldı`;
                              return (
                                <tr key={ilan.ID}>
                                  <td>
                                    <div className="fw-medium">{ilan.AD}</div>
                                    <small className="text-muted">
                                      #{ilan.ID}{ilan.KATEGORILER?.AD ? ` · ${ilan.KATEGORILER.AD}` : ""}
                                    </small>
                                  </td>
                                  <td>
                                    {ilan.KULLANICILAR?.AD_SOYAD || `#${ilan.KIMDEN_ID}`}
                                    {ilan.KULLANICILAR?.CEP_NO && (
                                      <small className="text-muted d-block">{ilan.KULLANICILAR.CEP_NO}</small>
                                    )}
                                  </td>
                                  <td>
                                    <Badge color={ilan.AKTIF_DURUM === "Aktif" ? "success" : "secondary"}>
                                      {ilan.AKTIF_DURUM}
                                    </Badge>
                                  </td>
                                  <td>
                                    {bitis ? bitis.toLocaleString("tr-TR") : "—"}
                                    <small className={`d-block ${suresiDoldu ? "text-danger" : "text-muted"}`}>
                                      {kalanMetin}
                                    </small>
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <UncontrolledDropdown>
                                        <DropdownToggle color="warning" size="sm" outline caret
                                          disabled={sureLoading === ilan.ID} title="Süreyi uzat">
                                          {sureLoading === ilan.ID
                                            ? <Spinner size="sm" />
                                            : <i className="bx bx-time-five" />}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem header>Süreyi uzat</DropdownItem>
                                          {[15, 30, 60, 180].map((dk) => (
                                            <DropdownItem key={dk}
                                              onClick={() => degerlemeSureAyarla({
                                                ilanId: ilan.ID, ekDakika: dk, yenidenAktif: true,
                                              })}>
                                              +{dk} dakika
                                            </DropdownItem>
                                          ))}
                                          <DropdownItem divider />
                                          <DropdownItem onClick={() => handleDegerlemeYenidenAc(ilan)}>
                                            <i className="bx bx-refresh me-1" />
                                            Yeniden aç (süre gir)…
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )
                  ) : isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={talepler}
                      isGlobalFilter={true}
                      SearchPlaceholder="Talep ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Talep Detay Modal — tüm alanlar + ilana müdahale */}
      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Değerleme Talebi #{selectedTalep?.ID}
        </ModalHeader>
        <ModalBody>
          {selectedTalep && (
            <Row>
              <Col md={5}>
                {selectedTalep.ILANLAR?.GORSEL_YOLU ? (
                  <a href={selectedTalep.ILANLAR.GORSEL_YOLU} target="_blank" rel="noreferrer">
                    <img
                      src={selectedTalep.ILANLAR.GORSEL_YOLU}
                      alt={selectedTalep.ILANLAR?.AD || "İlan"}
                      className="img-fluid rounded border mb-2"
                      style={{ maxHeight: 220, objectFit: "cover", width: "100%" }}
                    />
                  </a>
                ) : (
                  <div className="border rounded d-flex align-items-center justify-content-center text-muted mb-2" style={{ height: 160 }}>
                    Görsel yok
                  </div>
                )}
                {selectedTalep.ILANLAR?.ACIKLAMA && (
                  <div className="small text-muted" style={{ whiteSpace: "pre-wrap" }}>
                    {selectedTalep.ILANLAR.ACIKLAMA}
                  </div>
                )}
              </Col>
              <Col md={7}>
                <table className="table table-sm table-bordered mb-3">
                  <tbody>
                    <tr>
                      <th style={{ width: 150 }}>İlan</th>
                      <td>
                        {selectedTalep.ILANLAR?.AD || `İlan #${selectedTalep.ILAN_ID}`}
                        <small className="text-muted d-block">
                          #{selectedTalep.ILAN_ID} · Sahibi: Kullanıcı #{selectedTalep.ILANLAR?.KIMDEN_ID ?? "-"}
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <th>İlan Fiyatı</th>
                      <td>{selectedTalep.ILANLAR?.FIYAT != null ? `${parseFloat(selectedTalep.ILANLAR.FIYAT).toLocaleString("tr-TR")} ${selectedTalep.ILANLAR?.PARA_BIRIMI === "EUR" ? "€" : "₺"}` : "-"}</td>
                    </tr>
                    <tr>
                      <th>Konum</th>
                      <td>{[selectedTalep.ILANLAR?.KONUM_ILCE, selectedTalep.ILANLAR?.KONUM_IL].filter(Boolean).join(" / ") || "-"}</td>
                    </tr>
                    <tr>
                      <th>Talep Eden</th>
                      <td>
                        {selectedTalep.KULLANICILAR?.AD_SOYAD || `Kullanıcı #${selectedTalep.TALEP_EDEN_KULLANICI_ID}`}
                        {selectedTalep.KULLANICILAR?.Mail_Adress && <small className="text-muted d-block">{selectedTalep.KULLANICILAR.Mail_Adress}</small>}
                        {selectedTalep.KULLANICILAR?.CEP_NO && <small className="text-muted d-block">{selectedTalep.KULLANICILAR.CEP_NO}</small>}
                      </td>
                    </tr>
                    <tr>
                      <th>Tahmini Değer</th>
                      <td className="fw-bold">{selectedTalep.TAHMINI_DEGER != null ? `${parseFloat(selectedTalep.TAHMINI_DEGER).toLocaleString("tr-TR")} ₺` : "-"}</td>
                    </tr>
                    <tr>
                      <th>Tahmini Karkas</th>
                      <td>{selectedTalep.TAHMINI_KARKAS_KILO != null ? `${parseFloat(selectedTalep.TAHMINI_KARKAS_KILO).toLocaleString("tr-TR")} kg` : "-"}</td>
                    </tr>
                    <tr><th>Talep Tarihi</th><td>{selectedTalep.TALEP_TARIHI ? new Date(selectedTalep.TALEP_TARIHI).toLocaleString("tr-TR") : "-"}</td></tr>
                    <tr><th>Talep Durumu</th><td>{durumBadge(selectedTalep.DURUM)}</td></tr>
                    <tr>
                      <th>Değerleme Bitiş</th>
                      <td>
                        {selectedTalep.ILANLAR?.BITIS_TARIHI
                          ? new Date(selectedTalep.ILANLAR.BITIS_TARIHI).toLocaleString("tr-TR")
                          : <span className="text-muted">Başlamadı (ilan aktifleşince 1 saat)</span>}
                      </td>
                    </tr>
                    <tr>
                      <th>İlan Durumu</th>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          {ilanDurumBadge(selectedTalep.ILANLAR?.AKTIF_DURUM)}
                          {selectedTalep.ILANLAR && (
                            <Input
                              type="select"
                              bsSize="sm"
                              style={{ maxWidth: 140 }}
                              value={selectedTalep.ILANLAR.AKTIF_DURUM || ""}
                              disabled={ilanDurumLoading === selectedTalep.ILANLAR.ID}
                              onChange={(e) => handleIlanDurum(selectedTalep, e.target.value)}
                            >
                              <option value="Aktif">Aktif</option>
                              <option value="Pasif">Pasif</option>
                              <option value="Beklemede">Beklemede</option>
                            </Input>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button color="danger" outline onClick={() => handleDeleteTalep(selectedTalep)}>
            <i className="bx bx-trash me-1" /> Talebi Sil
          </Button>
          <div className="d-flex gap-2">
            <Button color="primary" onClick={() => { setDetailModal(false); handleOpenEdit(selectedTalep); }}>
              <i className="bx bx-edit me-1" /> Durumu Değiştir
            </Button>
            <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          Talep Durumu Güncelle
        </ModalHeader>
        <ModalBody>
          <p><strong>İlan:</strong> {selectedTalep?.ILANLAR?.AD || `İlan #${selectedTalep?.ILAN_ID}`}</p>
          <FormGroup>
            <Label>Uzman ID</Label>
            <Input
              type="number"
              value={editUzmanId}
              onChange={(e) => setEditUzmanId(e.target.value)}
              placeholder="Uzman kullanıcı ID"
            />
            <small className="text-muted">
              DEGERLEME_UZMANI_ID kolonu mobil uygulamada ve API'de hiçbir yerde okunmuyor —
              yalnızca kayıt amaçlı. Değerlemeyi etkileyen alan "Durum".
            </small>
          </FormGroup>
          <FormGroup>
            <Label>Durum</Label>
            <Input
              type="select"
              value={editDurum}
              onChange={(e) => setEditDurum(e.target.value)}
            >
              <option>Beklemede</option>
              <option>Kabul Edildi</option>
              <option>Reddedildi</option>
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={editLoading}>İptal</Button>
          <Button color="primary" onClick={handleEditSave} disabled={editLoading}>
            {editLoading ? <><Spinner size="sm" className="me-1" />Kaydediliyor...</> : "Kaydet"}
          </Button>
        </ModalFooter>
      </Modal>
      <KullaniciIletisimModal
        isOpen={!!iletisimTalep}
        toggle={() => setIletisimTalep(null)}
        tip="DEGERLEME"
        ilgiliId={iletisimTalep?.ILANLAR?.ID}
        ilgiliBaslik={iletisimTalep?.ILANLAR?.AD}
        kullanici={iletisimTalep ? { ID: iletisimTalep.TALEP_EDEN_KULLANICI_ID, ...(iletisimTalep.KULLANICILAR || {}) } : null}
      />
    </React.Fragment>
  );
};

export default DegerlemeTalepleri;
